import { render, staticRenderFns } from "./projectExperience.vue?vue&type=template&id=5f2f5d0d&scoped=true&"
import script from "./projectExperience.vue?vue&type=script&lang=js&"
export * from "./projectExperience.vue?vue&type=script&lang=js&"
import style0 from "./projectExperience.vue?vue&type=style&index=0&id=5f2f5d0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f5d0d",
  null
  
)

component.options.__file = "projectExperience.vue"
export default component.exports